import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserTerraformGame from 'src/games/DesertTerraformGame/Main';

interface TerraformingGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class TerraformingGame extends React.Component<TerraformingGameProps> {
    constructor(props: TerraformingGameProps) {
        super(props);
        bindAllOfThis(this, TerraformingGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserTerraformGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default TerraformingGame;



// WEBPACK FOOTER //
// ./src/pages/game/DesertTerraformGame.tsx